import script from "./RoleSectionListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSectionListModal.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSectionListModal.vue?vue&type=style&index=0&id=8d27445e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d27445e"]])

export default __exports__